const templates = {
    twitch: 'https://static-cdn.jtvnw.net/emoticons/v1',
    bttv: 'https://cdn.betterttv.net/emote',
    ffz: 'https://cdn.frankerfacez.com/emoticon',
    sevenTV: 'https://cdn.7tv.app/emote'
};

export function cdn(path) {
    return `https://cdn.streamelements.com/assets/chat-stats-assets/${path}`
}

export function getAsset(path) {
    return `https://cdn.streamelements.com/assets/${path}`
}

export function getEmote(provider, id, size = 1) {
    // console.log(provider);


    switch (provider) {
        case 'twitch':
        case 'twitchEmotes':
            return `${templates.twitch}/${id}/${size}.0`;
        case 'bttv':
        case 'bttvEmotes':
            return `${templates.bttv}/${id}/${size}x`;
        case 'ffz':
        case 'ffzEmotes':
            return `${templates.ffz}/${id}/1`;
        case 'sevenTV':
        case 'sevenTVEmotes':
                return `${templates.sevenTV}/${id}/1x.webp`;
        default:
            return ''
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/cdn.js